exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cw-line-wrapper[data-v-fdcc7b2a]{border-bottom:1px solid #becdd7;display:none;visibility:hidden}", ""]);

// exports
